import { t } from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import BaseListContainer from '../baseContainers/BaseListContainer';
import ActionLink from '../components/ActionLink';
import YesNoDialog from '../components/YesNoDialog';
import CriteriaDropdownComponent from '../components/criteria/CriteriaDropdownComponent';
import CriteriaTextComponent from '../components/criteria/CriteriaTextComponent';
import SquareColorComponent from '../components/inputs/SquareColorComponent';
import DocumentTypeService from '../services/DocumentTypeService';
import CriteriaMultiSelectComponent from '../components/criteria/CriteriaMultiSelectComponent';
import CountryService from '../services/CountryService';
import DocumentTypeEditDialog from '../containers/DocumentTypeEditDialog'

class DocumentTypeListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new DocumentTypeService());
        this.state = {
            list: [],
            countries: [],
            loading: true,
            size: 0,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            statusOptions: [],
            roleTypeOptions: [],
            dialogVisibile: false,
            deleteConfirmDialogVisible: false,
            element: this.initNewElement(),
        };
        this.handleOpenNewDialog = this.handleOpenNewDialog.bind(this);
        this.countryService=new CountryService();
    }

    initNewElement(){
        return {
            name: '',                
                status: {enumValue: 'ACTIVE', label: 'Aktywny'},
            color:'',    
            country: {}
        }
    }

    updateSearchCriteria(criteria) {
        return {
            name: criteria.login,          
            status: criteria.status,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }

    getCleanSearchCriteria() {
        return {
            name: '',            
            status: {enumValue: 'ACTIVE', label: 'Aktywny'},
            id: null,
            firstResult: 0,
            maxResults: 10,
            sortField: 'id',
            sortAsc: true,
        };
    }

    initializeFromBackend() {
        this.enumService
            .getEnumList('DocumentTypeStatus')
            .then((statusOptions) =>
                this.setState({
                    statusOptions,
                })
            )
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy statusów');
            });
        this.countryService.getAll()
        .then((countries)=>{
            this.setState({
                countries,
            })
        })
    }

    renderCriteria() {
        return (
            <div className='row'>
                <CriteriaTextComponent
                    id='name-sc'
                    name='name'
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.name}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    label={'Nazwa'}
                    global={true}
                    refreshFromBackend
                    timeoutHandler={this.refreshTable}
                />                
               
                <CriteriaDropdownComponent
                    id='status-sc'
                    name='status'
                    showClear
                    label={'Status'}
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.status}
                    options={this.state.statusOptions}
                    placeholder='Wszystkie'
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    optionLabel='label'
                    refreshFromBackend
                />
                
                <CriteriaMultiSelectComponent
                    id='countries'
                    name='countries'
                    label={t('documentType.countries')}
                    colClass='col-md-4'
                    onChange={this.handleChangeSc}
                    options={this.state.countries}
                    optionLabel='name'
                    value={this.state.criteria.countries}                                            
                    dataKey='id' 
                    refreshFromBackend
                    timeoutHandler={this.refreshTable}
                    filterOptionValue='label'
                    filter={true}
                    filterBy='name'
                />
            </div>
        );
    }
    enumTemplate(field, rowData) {
        if (rowData[field] && rowData[field].label) {
            return rowData[field].label;
        } else if (rowData[field]) {
            return rowData[field];
        }
        return '';
    }

    actionTemplate(rowData) {
        return (
            <span>
            <ActionLink
                iconName='mdi-pencil'
                iconSide='left'
                iconSize='icon-large'
                handleClick={(e) => this.handleOpenEditDialog(e, rowData)}
                variant='blue'
                className='edit-blue-link'
                key={'view-button'}
                rendered={rowData.status.enumValue ==='ACTIVE'}
            />
           <ActionLink
                 iconName='mdi-delete'
                 iconSide='left'
                 iconSize='icon-large'
                handleClick={(e) => this.handleOpenDeleteDialog(e, rowData)}
                variant='blue'
                className='edit-blue-link'
                key={'delete-button'}
                rendered={rowData.status.enumValue ==='ACTIVE'}
            />
           </span>
        );
    }

    handleOpenEditDialog(e, rowData) {
        if (e) {
            e.preventDefault();
        }
        this.setState({dialogVisibile: true, element: this.cloneElement(rowData), dialogViewMode: 'EDIT'});
    }

    handleOpenDeleteDialog(e, rowData) {
        if (e) {
            e.preventDefault();
        }
        this.setState({deleteConfirmDialogVisible: true, element: rowData, dialogViewMode: 'DELETE'});
    }

    prepareColumns() {
        const result = [
            {field: 'name', header: 'Nazwa', sortable: true},                        
            {field: 'status', header: 'Status', sortable: true, body: this.enumTemplate.bind(this, 'status')},
            {field: 'country.name', header: 'Kraj', sortable: true}
        ];
        if (this.authService.isUserInRole('ROLE_USER_DOCUMENT_TYPE_EDIT')) {
            result.push({
                key: 'actions',
                header: t('list.actions'),
                body: this.actionTemplate,
                className: 'table-column-action',
            })
        }
        return result;
    }
    squareComponent(rowData){
        return <SquareColorComponent value={rowData.color.value} />
    }

    prepareHeaderItems() {
        return this.authService.isUserInAnyRole('ROLE_USER_DOCUMENT_TYPE_EDIT')
            ? [
                  {
                      label: t('documentType.newButton'),
                      type: 'BUTTON',
                      className: 'float-right',
                      variant: 'blue',
                      iconName: 'mdi-plus',
                      iconSide: 'left',
                      iconColor: 'white',
                      onClick: this.handleOpenNewDialog,
                  },
              ]
            : [];
    }
    handleOpenNewDialog(e) {
        let basicElement = this.initNewElement();       
        if (e) {
            e.preventDefault();
        }
        this.setState({dialogVisibile: true, element: basicElement, dialogViewMode: 'NEW'});
    }

    handleDelete(e){
        if (e) {
            e.preventDefault();
        }
        console.log('delete {}', this.state.element)              
        this.service
            .remove(this.state.element)
            .then((response) => {
                this.blockUi();
                this.persistMessage('success', '', t('documentType.deleteSuccess'));
            })
            .catch((err) => {
                this.persistMessage('error', '', t('documentType.deleteError'));               
            })
            .finally(() => {
                this.afterObjectUpdate();
                this.setState({deleteConfirmDialogVisible: false});
            });
        
    }

    afterObjectUpdate() {       
        this.readMessage();
        this.refreshTable();
        this.unblockUi();
    }

    render() {
        return (
            <div className='container-fluid document-types-list'>
                <BreadcrumbsItem to='/document-types-list'>{'Typy dokumentów'}</BreadcrumbsItem>
                {this.renderView()}
                {this.state.dialogVisibile ? (
                    <DocumentTypeEditDialog
                        className='document-types-dialog'
                        key={`document-types-dialog-${this.state.element?.id}`}
                        element={this.state.element}
                        onHide={(e) => this.setState({dialogVisibile: false})}
                        visible={this.state.dialogVisibile}
                        viewMode={this.state.dialogViewMode}                        
                        afterSave={(e) => {
                            this.setState({dialogVisibile: false});
                           this.afterObjectUpdate();
                        }}
                        blockUi={this.blockUi}
                        unblockUi={this.unblockUi}
                        countries={this.state.countries}
                        _isMounted={this._isMounted}
                    />
                ) : null}
                {this.state.deleteConfirmDialogVisible ? (
                <YesNoDialog
                    visible={this.state.deleteConfirmDialogVisible}
                    header={t('documentType.deleteHeader')}
                    name='visible'
                    onChange={(type, x, target) => {
                        if (target.value) {
                        
                            this.handleDelete();
                        } else {
                            this.setState({deleteConfirmDialogVisible: false})
                        }
                    }}
                    onHide={() => this.setState({deleteConfirmDialogVisible: false})}
                     >
                        {t('details.deleteConfirmation')+'\n' + this.state.element.name}
                    </YesNoDialog> 
                ) : null}
            </div>
        );
    }
}

DocumentTypeListContainer.defaultProps = {
    detailUrl: '/#/document-types/details',
    newUrl: '/#/document-types/create',
    lazy: true,
};

DocumentTypeListContainer.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
};

export default DocumentTypeListContainer;
